import { flattenDeep, findIndex } from 'lodash';

import * as constants from './TrailModeCourse.constants';
import * as services from './TrailModeCourse.service';

const getVideos = collection =>
  Array.isArray(collection) &&
  flattenDeep(flattenDeep(collection.map(v => v.readingList)).map(v => v.bulletList)).map(
    (v, i, arr) => {
      return {
        bulletName: v.bulletName,
        bulletId: v.bulletId,
        videoId: v.videoId,
        speed1: v.vpath,
        speed1Dot3: v.vpath_1_3,
        speed1Dot5: v.vpath_1_5,
        speed2: v.vpath_2,
        isLatest: i === arr.length - 1,
        endOfReading: v.endOfReading ? true : false,
        collected: v.collected ? true : false,
      };
    }
  );

const state = {
  Books: [],
  Course: {},
  Collection: [],
  CollectionData: [],
  ReadyToPlayVideos: [],
  isRequest: false,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.GET_TRAIL_COURSE_SUCCESS](state, Course) {
    if (Course) {
      state.Course = Course;
      state.Books = Course.books;
      state.Collection = Course.collection;
      state.CollectionData = Course.collection;
      state.ReadyToPlayVideos = getVideos(state.Collection);
    } else {
      state.Course = {};
      state.Books = [];
      state.Collection = [];
      state.CollectionData = [];
      state.ReadyToPlayVideos = [];
    }
  },

  [constants.FILTER_TRAIL_COLLECTION_BOOK](state, value) {
    if (value != 0) {
      state.Collection = state.CollectionData.filter(v => v.bookId == value);
    } else {
      state.Collection = state.CollectionData;
    }
    state.ReadyToPlayVideos = getVideos(state.Collection);
  },

  [constants.ADD_VIDEO_TO_FAVORITE_LIST](state, bulletId) {
    const index = findIndex(state.ReadyToPlayVideos, v => v.bulletId === bulletId);
    if (index != -1) {
      const elem = state.ReadyToPlayVideos[index];
      elem.collected = !elem.collected;
    }
  },

  [constants.REMOVE_UNFOLLOW_VIDEOS](state) {
    const unFollowArr = state.ReadyToPlayVideos.filter(v => !v.collected);
    if (unFollowArr.length) {
      unFollowArr.forEach(v => {
        state.Collection.forEach(collection => {
          collection.readingList.forEach(reading => {
            reading.bulletList.forEach((bullet, i) => {
              if (bullet.bulletId === v.bulletId && !v.collected) {
                reading.bulletList.splice(i, 1);
              }
            });
          });
        });
      });

      state.Collection.forEach(collection => {
        collection.readingList.forEach((reading, i) => {
          if (!reading.bulletList.length) {
            collection.readingList.splice(i, 1);
          }
        });
      });

      state.Collection.forEach((collection, i) => {
        if (!collection.readingList.length) {
          state.Collection.splice(i, 1);
        }
      });
      state.ReadyToPlayVideos = getVideos(state.Collection);
    }
  },
};

const actions = {
  async getTrailCourse({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getTrailCourse(payload);
    commit(constants.GET_TRAIL_COURSE_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async addToFavoriteList({ commit }, payload) {
    const res = await services.addToFavoriteList(payload);
    if (res.data.data) {
      commit(constants.ADD_VIDEO_TO_FAVORITE_LIST, payload.bulletId);
    }
  },
};

const getters = {
  ReadyToPlayVideos: state => state.ReadyToPlayVideos,
  Books: state => state.Books,
  FilterData: state =>
    Array.isArray(state.CollectionData) &&
    state.CollectionData.map(v => ({ bookName: v.bookName, bookId: v.bookId })),
  Collection: state => state.Collection,
  isRequest: state => state.isRequest,
  Course: state => state.Course,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
